import { CONFIRM_COLOR } from '@/helpers/constants';


const state = {
  show: false,
  headline: '',
  details: '',
  color: CONFIRM_COLOR.INFO,
  action: 'Yes',
  resolve: null
};

const actions = {
  confirm({ commit }, payload) {
    commit('setInfo', { key: 'color', value: payload.color ? payload.color : CONFIRM_COLOR.INFO });
    commit('setInfo', { key: 'headline', value: payload.headline ? payload.headline : 'Please confirm' });
    commit('setInfo', { key: 'details', value: payload.details ? payload.details : 'Are you sure you want to do this? This action is irreversible.' });
    commit('setInfo', { key: 'action', value: payload.action ? payload.action : 'Yes' });
    commit('open');
    return new Promise((resolve) => {
      commit('setInfo', { key: 'resolve', value: resolve });
    });
  }
};

const mutations = {
  setInfo(state, { key, value }) {
    state[key] = value;
  },
  open(state) {
    state.show = true;
  },
  close(state) {
    state.show = false;
  },
  resolve(state, payload) {
    state.resolve(payload);
    state.resolve = null;
    state.show = false;
  }
};

const getters = {
  isDisplayed: (state) => state.show,
};

export default {
  namespaced: true,
  state: state,
  getters,
  actions,
  mutations,
};
